import { getCoreUtils } from "./kCoreHandler";

/** Shared code-point clipping. Raw text stays unchanged unless clipped; compact labels may
 * trim the clipped tail and append a suffix without ever splitting an emoji surrogate pair. */
export class kTextClipCore {
    public static ClipCodePoints = (Text: string, Limit: number, Suffix: string = "", TrimEnd: boolean = false): string => {
        if (getCoreUtils().KErrorMode === true) { return ""; }
        try {
            if (Text === undefined || Text === null || Text === "") { return ""; }
            if (Text.length <= Limit) { return Text; }
            const Points: string[] = Array.from(Text);
            if (Points.length <= Limit) { return Text; }
            let Clipped: string = Points.slice(0, Limit).join("");
            if (TrimEnd === true) { Clipped = Clipped.trimEnd(); }
            return Clipped + Suffix;
        } catch (e) { getCoreUtils().KGlobalErrorHandler(e, "kTextClipCore.ClipCodePoints"); return ""; }
    };
}
